function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtificialIntelligence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M127.467,432.733H111.4c-35.47,0-64.267-28.8-64.267-64.267c0-26.598,21.598-48.2,48.2-48.2H79.267 C43.797,320.267,15,291.467,15,256s28.797-64.267,64.267-64.267h16.067c-26.602,0-48.2-21.602-48.2-48.2 c0-35.467,28.797-64.267,64.267-64.267h16.067"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M384.533,432.733H400.6c35.47,0,64.267-28.8,64.267-64.267c0-26.598-21.598-48.2-48.2-48.2h16.067 c35.47,0,64.267-28.8,64.267-64.267s-28.797-64.267-64.267-64.267h-16.067c26.602,0,48.2-21.602,48.2-48.2 c0-35.467-28.797-64.267-64.267-64.267h-16.067"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M159.6,111.4c-17.735,0-32.133-14.396-32.133-32.133C127.467,43.8,156.264,15,191.733,15S256,43.8,256,79.267 C256,43.8,284.797,15,320.267,15s64.267,28.8,64.267,64.267c0,17.738-14.398,32.133-32.133,32.133"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M159.6,400.6c-17.735,0-32.133,14.396-32.133,32.133c0,35.467,28.797,64.267,64.267,64.267S256,468.2,256,432.733 C256,468.2,284.797,497,320.267,497s64.267-28.8,64.267-64.267c0-17.738-14.398-32.133-32.133-32.133"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M175.667,304.2v-64.267c0-8.523,3.385-16.693,9.412-22.718c6.026-6.033,14.199-9.415,22.721-9.415 c8.523,0,16.696,3.382,22.721,9.415c6.027,6.025,9.412,14.195,9.412,22.718c0,28.036,0,64.267,0,64.267"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 175.667,
    y1: 272.067,
    x2: 239.933,
    y2: 272.067
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 288.133,
    y1: 207.8,
    x2: 336.333,
    y2: 207.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 288.133,
    y1: 304.2,
    x2: 336.333,
    y2: 304.2
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 312.233,
    y1: 207.8,
    x2: 312.233,
    y2: 304.2
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 256,
    y1: 79.267,
    x2: 256,
    y2: 143.533
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 256,
    y1: 432.733,
    x2: 256,
    y2: 368.467
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtificialIntelligence);
export default __webpack_public_path__ + "static/media/artificial-intelligence.026f1202d798c58b6d9daa764870299c.svg";
export { ForwardRef as ReactComponent };